import {deleteRecording} from '../meetings/deleteRecording'

export function cancelRecordingUpload(recording,recordingContext) {	
	if(recordingContext){
		recordingContext.cancelUpload(recording.upload_id)
	}	
	deleteRecording(recording.recording_id)
}

